import { combineReducers } from 'redux';
import {
  contactShareStatusesReducer as contacts,
  ContactShareStatusesState,
  labelForContactPermission,
  supportedContactPermissions,
} from './contacts';
import {
  groupShareStatusesReducer as groups,
  GroupShareStatusesState,
  labelForGroupPermission,
  supportedGroupPermissions,
} from './groups';

export type SharedResourceType = 'contact' | 'group';

export interface ShareStatusesState {
  contacts: ContactShareStatusesState;
  groups: GroupShareStatusesState;
}

export const labelsForPermissionsByResourceType = {
  contact: labelForContactPermission,
  group: labelForGroupPermission,
};

export const supportedPermissionsByResourceType = {
  contact: supportedContactPermissions,
  group: supportedGroupPermissions,
};

export const labelForSharedResourceType: Record<SharedResourceType, string> = {
  contact: 'profile',
  group: 'group',
};

export const shareStatusesReducer = combineReducers({
  contacts,
  groups,
});
